import { useState, useEffect } from "react";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import TableCard from "../tableCard/TableCard.jsx";

import EntryStorageModal from "./EntryStorageModal";
import ExitStorageModal from "./ExitStorageModal";

export default function InventoryTab({ users, content, setUpdater }) {
  // const { execute: storeHouse } = useAxios("api2/storehouse");

  // useEffect(() => {
  //   storeHouse().then(data => {
  //     // let inventory = [...data.whiteHouseItem];
  //     setContent(data.whiteHouseItem);
  //   });
  // }, []);
  function actions(value) {
    return (
      <div className="d-flex justify-content-center">
        <EntryStorageModal
          data={value}
          users={users}
          setUpdater={setUpdater}
        ></EntryStorageModal>
        <ExitStorageModal
          data={value}
          users={users}
          setUpdater={setUpdater}
        ></ExitStorageModal>
      </div>
    );
  }
  const [header, setHeader] = useState([
    { title: "نام محصول/خدمت", type: "title", name: "title" },
    { title: "تعداد کل ورود", type: "title", name: "enter_count" },
    { title: "تعداد کل خروج", type: "title", name: "exit_count" },
    { title: "موجودی", type: "title", name: "inventory" },
    { title: "تعداد آخرین ورودی", type: "title", name: "last_enter_count" },
    { title: "زمان آخرین ورودی", type: "title", name: "last_enter_tm" },
    { title: "کاربر آخرین ورودی", type: "title", name: "last_enter_uid" },
    { title: "تعداد آخرین خروجی", type: "title", name: "last_exit_count" },
    { title: "زمان آخرین خروجی", type: "title", name: "last_exit_tm" },
    { title: "کاربر آخرین خروجی", type: "title", name: "last_exit_uid" },
    { title: "عملیات", type: "operation", name: "operation" }
  ]);
  // const [content, setContent] = useState([]);
  const convertTimestampToDate = timeStamp => {
    const date = new DateObject({
      date: timeStamp * 1000,
      calendar: persian
    });
    let showDate;
    timeStamp != "" ? (showDate = date.format()) : (showDate = "-");
    return showDate;
  };
  return (
    <>
      {content.length > 0 ? (
        content.map(value => {
          return (
            <TableCard
              column={header}
              content={{
                ...value,
                last_enter_tm:
                  value.last_enter_tm != "" &&
                  value.last_enter_tm != null &&
                  value.last_enter_tm != "0"
                    ? convertTimestampToDate(value.last_enter_tm)
                    : "---",
                last_enter_uid:
                  value.last_enter_uid.lname != undefined
                    ? value.last_enter_uid.fname +
                      " " +
                      value.last_enter_uid.lname
                    : "---",
                last_exit_uid:
                  value.last_exit_uid.lname != undefined
                    ? value.last_exit_uid.fname +
                      " " +
                      value.last_exit_uid.lname
                    : "---",
                last_exit_tm:
                  value.last_exit_tm != "" &&
                  value.last_exit_tm != null &&
                  value.last_exit_tm != "0"
                    ? convertTimestampToDate(value.last_exit_tm)
                    : "---",
                operation: actions(value)
              }}
              bg={"pink_custom"}
              widthParent={"90%"}
            ></TableCard>
          );
        })
      ) : (
        <div>محصولی با این مشخصات یافت نشد.</div>
      )}
    </>
  );
}
